<ion-grid
	class="max-w-1336 content-box"
	*ngIf="getPropertyList$
| async as propertyList"
>
	<ng-container *ngIf="propertyList.isSkeleton">
		<ion-grid class="side-menu-wrapper text-center">
			<ion-spinner class="ion-spinner"></ion-spinner>
		</ion-grid>
	</ng-container>
	<ion-row>
		<ion-col col="12">
			<dx-data-grid
				id="gridContainer"
				[dataSource]="propertyList.data"
				[allowColumnResizing]="true"
				[columnAutoWidth]="true"
				[showBorders]="true"
				*ngIf="propertyList.data"
			>
				<dxo-search-panel
					[visible]="true"
					[width]="240"
					placeholder="Search..."
				></dxo-search-panel>
				<dxo-header-filter> [visible]="showHeaderFilter" </dxo-header-filter>
				<dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>
				<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

				<dxi-column
					caption="ACTIONS"
					[allowFiltering]="false"
					[allowSorting]="false"
					cellTemplate="cellTemplate"
				>
				</dxi-column>
				<dxi-column caption="Id" dataField="id"> </dxi-column>
				<dxi-column dataField="name" caption="Name"></dxi-column>
				<dxi-column dataField="value" caption="Value"></dxi-column>

				<div *dxTemplate="let d of 'cellTemplate'">
					<a class="cursor" (click)="editProperty(d.data.id)">Edit</a> /
					<a class="cursor" (click)="deleteProperty(d.data.id)">Delete</a>
				</div>
				<dxo-toolbar>
					<dxi-item location="before">
						<div *dxTemplate class="informer">
							<ion-button (click)="createFaq()"
								><ion-icon name="add-outline"></ion-icon
							></ion-button>
						</div>
					</dxi-item>

					<dxi-item location="before">
						<div *dxTemplate class="informer">
							<p class="Heading_M">Add New Property</p>
						</div>
					</dxi-item>

					<dxi-item name="columnChooserButton"></dxi-item>

					<dxi-item name="searchPanel"></dxi-item>
				</dxo-toolbar>
			</dx-data-grid>
		</ion-col>
	</ion-row>
</ion-grid>
